import React, { useEffect } from 'react';
import { MdOutlineQuickreply } from 'react-icons/md';
import { roundNumber } from '../utility';
import YoutubeEmbed from './YouTube';
import { extractYoutubeId } from '../utility';
import moment from 'moment';

const More = React.memo(props => {
	const { more, commentsMore, resetScroll } = props;
	useEffect(()=>{
		resetScroll();
	}, [more, commentsMore, resetScroll]);

	let moreType = props.moreType;


	let mainContent = null;

	// Show commentsMore if it exists and is a non-empty array
	if (commentsMore && Array.isArray(commentsMore) && commentsMore.length > 0) {
		mainContent = (
			<div className="content">
				{displayThread(commentsMore, 0)}
			</div>
		);
	} else if(moreType === "image") {
		mainContent = (
			<>
				<div className="image-more" key={props.more} style={{minHeight: 300, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
					<img alt="thumbnail" style={{maxWidth: "100%", marginBottom: 34}} alt-text="image preview" src={props.more} />
				</div>
			</>
		);
	} else if (moreType === "reddit-video") {
		const mediaPermalink = props.permalink.replace("reddit", "www.redditmedia")
		mainContent = (
			<>
				<div className="reddit-video-more" key={props.more} style={{position: "relative"}}>
					<iframe
						title={`reddit-video-more-${props.more}`}
						id="reddit-embed"
						allowFullScreen={true}
						src={`${mediaPermalink}?ref_source=embed&amp;ref=share&amp;embed=true`}
						sandbox="allow-scripts allow-same-origin allow-popups"
						style={{height: "90vh", width:"100%"}}
					/>
				</div>
			</>
		);
	} else if(moreType === 'reddit-embed' || moreType === "reddit-gallery"){
		const mediaPermalink = props.permalink.replace("reddit", "www.redditmedia")
		mainContent = (
			<>
				<div key={props.more} style={{position: "relative"}}>
					<iframe
						title={`reddit-embed-${props.more}`}
						id="reddit-embed"
						allowFullScreen={true}
						src={`${mediaPermalink}?ref_source=embed&amp;ref=share&amp;embed=true`}
						sandbox="allow-scripts allow-same-origin allow-popups"
						style={{height: "90vh", width:"100%"}}
					/>
				</div>
			</>
		);
	} else if(moreType === 'gfycat'){
		const mediaUrl = props.more.replace('https://gfycat.com', 'https://gfycat.com/ifr')
		mainContent = (
			<>
				<div style={{position:'relative', paddingBottom:'calc(152.61% + 44px)'}}>
					<iframe
						title={`gfycat-embed-${props.more}`}
						src={mediaUrl}
						style={{ frameborder:'0', scrolling:'no', width:'100%', height:'100%', maxHeight: "90vh", position:"absolute", top:0, left:0}}
						allowFullScreen
					></iframe>
				</div>
			</>
		);
	} else if(moreType === "url" && extractYoutubeId(props.more)) {
		mainContent = (
			<>
				<div key={props.more} style={{width: "100%", height: "100%"}}>
					<YoutubeEmbed embedId={extractYoutubeId(props.more)}/> 
				</div>
			</>
		);
	} else if(moreType === "url" && props.more ) {
		mainContent = (
			<>
				<div key={props.more}>
					<a href={props.more} className="embedly-card">
						<span style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", overflow: "hidden" }}>External Link</span>
					</a>
				</div>
			</>
		);
	} else {
		mainContent = props.more
			? <div className="content">
				{displayThread(props.more, 0)}
			</div>
			: null;
	}

	return (
		<>
			{mainContent}
		</>
	);
})

function scrollToId(id) {
	var elem = document.getElementById(id); //chat container's ID where your messages stack up.
	if (elem) {
		elem.scrollIntoView();
	}
}

function changeVisibleExpand(event) {
	event.stopPropagation();
	event.currentTarget.parentNode.classList.toggle("hidden");
}

function changeVisibleDiv(event) {
	event.stopPropagation();
	event.currentTarget.classList.toggle("hidden");
}

function rollUp(event, commentId){
	event.stopPropagation();

	let parentNode = event.currentTarget.parentNode.parentNode;
	let childNodes = parentNode.childNodes;

	for(let i = 0; i < childNodes.length; i++) {
		if(childNodes[i].classList.contains("thread")){
			if(childNodes[i].id === commentId){
				break;
			}
			childNodes[i].classList.add('hidden');
		}
	}

	scrollToId(parentNode.id);
}

function displayThread(thread, depth) {
	let nextDepth = depth + 1;

	return thread.map(( item ) => {
		if( item.body ) {
			return <div onClick={ event => changeVisibleDiv( event ) } key={ item.id } id={ item.id } className={ depth%2 === 0 ? "even thread" : "odd thread"}>
				<div className="roll-up" onClick={event => rollUp(event, item.id)}/>
				<div className="thread-text" onClick={event => changeVisibleExpand(event)}>
					<div>
						{item.body}
					</div>
					<span className="comment-meta">
						{ roundNumber( item.score )}&nbsp;&nbsp;
						<a rel="noreferrer" style={{color: "#949494"}} target="_blank" href = { "https://reddit.com/user/" + item.author } onClick = { e => e.stopPropagation() }>{item.author}</a>
						<a rel="noreferrer" target="_blank" href={"https://reddit.com" + item.permalink} onClick={e=>e.stopPropagation()}><MdOutlineQuickreply style={{fontSize:"15px", paddingBottom:"1px", color: "lightgrey", marginLeft: "7px"}}/></a>
						<span style={{marginLeft: 6}}>{moment(item.created*1000).fromNow(true)}</span>
					</span>
				</div> 
				{item.thread && displayThread(item.thread, nextDepth, item.id )}
			</div>;
		} else {
			return <div key={item.id} id={item.id} className={depth%2 === 0 ? "even more" : "odd more"}><a onClick={e => e.stopPropagation()} target="_blank" rel="noopener noreferrer" href={"https://reddit.com" + item.permalink} className="continue-reddit">Thread Continues at Reddit</a></div>;
		}
	});
}

export default More;
